import { createFileRoute } from "@tanstack/react-router"

import { HistoryTab } from "~/features/feature-flags/pages"

export const Route = createFileRoute("/_auth/internal/feature-flags/$flagKey/_layout/history")({
  component: RouteComponent,
})

function RouteComponent() {
  return <HistoryTab flagKey={Route.useParams().flagKey} />
}
